import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { AssignedProcedureDTO, ProcedureDTO } from '../Models/Procedure.model';
import { SpecialityDTO } from '../Models/Speciality.model';
import { AppWideUser, Token } from "../Services/AppUserProfile";
import { SrubUpService } from '../Services/ScrubUp.service';
import {environment} from '../../environments/environment';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
declare var swal: any;

@Component({
  selector: 'app-speciality',
  templateUrl: './speciality.component.html',
  styleUrls: ['./speciality.component.scss'],
  providers: [SrubUpService, CookieService]
})
export class SpecialityComponent implements OnInit {
  specialityForm: FormGroup;
  submitted = false;
  updatespecialityId:any;
  public baseurl: string = environment.base_url;
  public image:any;
  public imageUrl:any;
  display='none'; //default Variable
  getAdminValues: boolean;
  imageUploadApiUrlLength: number;
  isImpersonateMode: boolean;
  specialityName: string;
  name:any;
  id:number;
  description: string;
  imagePath: string;

  index: boolean;
  edit: boolean;

  universalHideAndShowMpId;
  showDetails;
  mpId: number;
  profileId: number;
  createNew: boolean;
  public loading = false;
  nextButtonDisabled: boolean;

  invisible: number;
  editvisi: number;
  showEditingDiv: number;
  iValue: number;
  uploadUrl: string;
  Headers: any;
  specialityId: number;
  editSpecialityId: number;
  procedures: Array<ProcedureDTO>;
  specialities: Array<SpecialityDTO>;
  assignedProcedures: Array<ProcedureDTO>;
  assignedProcedureId: number;
  assignedProcedureIds: Array<string>;
  toAssignProcedures: Array<AssignedProcedureDTO>;
  toAssignprocedure: AssignedProcedureDTO;
  loginUserId: number;
  myHeadersForLogo: { [name: string]: any };
  myHeadersForIcon: { [name: string]: any };
  myHeadersForIconSelected: { [name: string]: any };
  myHeadersForLogoSelected: { [name: string]: any };
  tempUrl: Array<string>;

  constructor(private formBuilder: FormBuilder,private router: Router, private _sanitizer: DomSanitizer, private token: Token, private appUserDetails: AppWideUser, private cookieService: CookieService, private scrubUpService: SrubUpService) {
    
    if (this.appUserDetails.UserName == undefined && this.token.access_token == undefined || this.appUserDetails.UserName == null && this.token.access_token == null) {
      if (cookieService.check('AppWideUser') && cookieService.check('Token'))
        this.appUserDetails = JSON.parse(this.cookieService.get('AppWideUser'));
      this.token = JSON.parse(this.cookieService.get('Token'));
    }

    this.getAdminValues = true;

    this.isImpersonateMode = JSON.parse(this.cookieService.get('impersonation'));
    if (this.isImpersonateMode == true) {
      this.loginUserId = JSON.parse(this.cookieService.get('userId'));
    }
    else {
      this.loginUserId = this.appUserDetails.UserId;
    }

    this.tempUrl = new Array<string>();
    this.specialityId = 0;
    this.specialities = new Array<SpecialityDTO>();
    this.assignedProcedures = new Array<ProcedureDTO>();
    this.toAssignProcedures = new Array<AssignedProcedureDTO>();
    this.uploadUrl = this.baseurl + "api/Speciality/UploadSpecialityImage?userId=" + this.loginUserId;
    this.nextButtonDisabled = true;
    this.index = true;

    this.invisible = 0;
    this.editvisi = 0;

    this.showEditingDiv = -1;
    this.iValue = -1;
    this.InitAPICalls();
    this.procedures = new Array<ProcedureDTO>();
    this.imageUploadApiUrlLength = (this.baseurl + "api/Speciality/GetUploadedImage?imageName=").length;
  }

  Collapse() {
    this.UserClick(1);
    this.invisible = 1;
  }

  InitAPICalls() {
    this.myHeadersForLogo = {
      'Authorization': 'Bearer ' + this.token.access_token,
      'UserId': this.appUserDetails.UserId,
      'ModulePath': "Speciality",
      'Suffix': "_logo_selected.png",
      'SpecID': this.specialityId
    };
    this.myHeadersForLogoSelected = {
      'Authorization': 'Bearer ' + this.token.access_token,
      'UserId': this.appUserDetails.UserId,
      'ModulePath': "Speciality",
      'Suffix': "_logo_unselected.png",
      'SpecID': this.specialityId
    };
    this.myHeadersForIcon = {
      'Authorization': 'Bearer ' + this.token.access_token,
      'UserId': this.appUserDetails.UserId,
      'ModulePath': "Speciality",
      'Suffix': "_icon_selected.png",
      'SpecID': this.specialityId
    };
    this.myHeadersForIconSelected = {
      'Authorization': 'Bearer ' + this.token.access_token,
      'UserId': this.appUserDetails.UserId,
      'ModulePath': "Speciality",
      'Suffix': "_icon_unselected.png",
      'SpecID': this.specialityId
    };

  }
  openModalDialog(){
    this.specialityForm.controls.specialityName.setValue('');
    this.specialityForm.controls.description.setValue('');
    this.editvisi=0;
    this.imageUrl="";
    this.imagePath="";
    this.display='block'; //Set block css

  }
  closeModalDialog()
  {
    this.editvisi=0;
    this.display='none'; //set none css after close dialog
  }
  UserClick(btnCount) {
    this.edit = false;

    if (btnCount == 1) {
      this.specialityName = "";
      this.description = "";
      this.imagePath = "";
      this.specialityId = 0;
      this.edit = true;
      this.showEditingDiv = -1;
    }
    if (btnCount == 3) {
      this.edit = false;
      this.invisible = 0;
      this.specialityName = "";
      this.description = "";
      this.display='none';
    }
  }

  GetImage(imageSrc) {
    imageSrc.forEach(element => {
      this.scrubUpService.GetImage(this.token, element, this.appUserDetails.UserId).subscribe(ab => {
        this.specialities.forEach(a => {
          if (a.ImagePath == element) {
            a.ImageBase64 = "data:image/png;base64," + ab
          }
        });
      });
    });
  }

  OnUploadFinished($event: any) {
    let uploadStatus: string;
    //let imagevalidation = this.translateService.instant('imageValidation');
    const files = $event.target.files || $event.srcElement.files;
    const file = files[0];
    const type = this.checkExtension(file);
    if (file && type != -1) {
      this.image = file;
    // console.log( this.image);
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (event: any) => {
        this.imageUrl = event.target.result;
      };
    } else {
      //this.alertService.showDangerAlert(this.errorDialog, imagevalidation);
    }


  }
  checkExtension(file: any) {
    let mimeType = ['image/png', 'image/jpeg', 'image/jpg'];
    return mimeType.indexOf(file.type);
  }

  GetProcedures() {
    // this.loading = true;
    // this.getAdminValues = true;
    // this.scrubUpService.GetProcedures(this.token, this.appUserDetails.UserId, this.getAdminValues).subscribe(x => {
    //   if (x != null && x != undefined) {
    //     this.procedures = x;
    //     this.GetAssignedProcedures();
    //   }
    //   this.loading = false;
    // },
    //   error => {
    //     this.loading = false;
    //   })
  }

  GetSpecialities() {
// alert(3);
    this.loading = true;
    this.getAdminValues = true;
   // console.log("test1");
    this.scrubUpService.GetSpecialities(this.token, this.appUserDetails.UserId, this.getAdminValues).subscribe(x => { // to get specialities based on user id

      // console.log(x.status);
      if ( x['Data'] != null && x != undefined) {
        this.specialities = x['Data'];
        // this.specialities.forEach(element => {
        //   this.tempUrl.push(element.ImagePath);
        // });
        // this.GetImage(this.tempUrl);
      }
      this.loading = false;
    },
      error => {
        // console.log(error);
        // this.router.navigate(['login']);
        this.loading = false;
      })
  }

  specialitySelected(specialityId) {
    this.specialityId = specialityId;
    this.toAssignProcedures = [];
    this.mapAssignedProcedures();
    //this.toAssignProcedures = this.toAssignProcedures.filter(procedure => procedure.SpecialityId === specialityId);
  }

  AssignUserProcedures() {
    this.assignedProcedureIds = new Array<string>();
    for (let index = 0; index < this.toAssignProcedures.length; index++) {
      if (this.toAssignProcedures[index].IsChecked) {
        this.assignedProcedureIds[index] = this.toAssignProcedures[index].ProcedureId;
      }
    }
    this.loading = true;
    this.scrubUpService.AssignProcedures(this.token, this.assignedProcedureIds, this.specialityId, this.loginUserId).subscribe(x => {
      if (x == "success") {
        swal({
          title: 'Specialities Added Successfully',
          type: "success",
          timer: 2000,
          showConfirmButton: false
        }).catch(swal.noop);;
        this.toAssignProcedures = [];
        this.GetAssignedProcedures();

      }
      else {

      }
      this.loading = false;
    });
  }

  GetAssignedProcedures() {
    this.loading = true;
    this.getAdminValues = false;
    this.scrubUpService.GetProcedures(this.token, this.loginUserId, this.getAdminValues).subscribe(x => { // to get specialities based on user id
      if (x != null && x != undefined) {
        this.assignedProcedures = x;
        this.mapAssignedProcedures();
      }
      this.loading = false;
    },
      error => {
        this.loading = false;
      })
  }

  ResetAssigned() {
    this.toAssignProcedures = [];
    this.mapAssignedProcedures();
  }

  mapAssignedProcedures() {
    for (let index = 0; index < this.procedures.length; index++) {
      this.toAssignprocedure = new AssignedProcedureDTO();
      this.toAssignprocedure.ProcedureId = this.procedures[index].ID;
      this.toAssignprocedure.Description = this.procedures[index].Description;
      this.toAssignprocedure.Name = this.procedures[index].Name;
      this.toAssignprocedure.SpecialityId = this.procedures[index].SpecialityID;
      this.toAssignprocedure.UserId = this.procedures[index].UserID;
      this.toAssignprocedure.IsChecked = this.findObjectByKey(this.assignedProcedures, 'ID', this.procedures[index].ID) == null ? false : true;
      this.toAssignprocedure.disableAssigned = this.toAssignprocedure.IsChecked;
      this.toAssignProcedures.push(this.toAssignprocedure);
    }
    this.toAssignProcedures = this.toAssignProcedures.filter(procedure => procedure.SpecialityId === this.specialityId);
  }

  findObjectByKey(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
    return null;
  }
  EditSpeciality(specltyName: string, specltyDesc: string, specltyId: number, specltyImagePath: string, index: number) {
    this.editvisi=1;
this.display="block";
    // this.correctiveActionUpdateExists=false;
    if (this.showEditingDiv != -1) {
      if (this.iValue == index) {
        this.showEditingDiv = -1;
      }
      else {
        this.showEditingDiv = -1;
        this.showEditingDiv = index;
        this.iValue = index;
      }
      this.id = specltyId;
      this.specialityForm.controls.specialityName.setValue(specltyName);
      this.specialityForm.controls.description.setValue(specltyDesc);
      this.specialityName = specltyName;
      this.description = specltyDesc;
      this.specialityId = specltyId;
      this.imagePath = specltyImagePath;
      this.imageUrl = specltyImagePath;
      this.edit = false;
    }
    else {
       this.id = specltyId;
       this.specialityForm.controls.specialityName.setValue(specltyName);
       this.specialityForm.controls.description.setValue(specltyDesc);
      this.specialityName = specltyName;
      this.description = specltyDesc;
      this.specialityId = specltyId;
      this.imagePath = specltyImagePath;
      this.imageUrl = specltyImagePath;
      this.showEditingDiv = index;
      this.iValue = index;
      this.edit = false;
    }
    this.InitAPICalls();
  }

  OnCancel() {
    this.showEditingDiv = -1;
    this.editvisi = 0;
    this.specialityName = "";
    this.description = "";
    this.imagePath = "";
    this.specialityId = 0;
  }

  DeleteSpeciality(specltyId: any) {
    let specialityDel={'SpecialityId':specltyId};
   swal({
      title: 'Are you sure you want to Delete this Speciality?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-success',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Confirm',
      buttonsStyling: false,
      allowOutsideClick: false
    }).then(() => {
      this.loading = true;
          this.scrubUpService.DeleteSpeciality(this.token,specialityDel).subscribe(x => {
            if (x.Status == true) {
                  swal({
                    title: 'Speciality Deleted Successfully',
                    type: "success",
                    timer: 2000,
                    showConfirmButton: false
                  }).catch(swal.noop);;
                  this.OnCancel();
                  this.GetSpecialities();
                }
                else {
                  swal({
                    title: 'Could Not Delete Speciality',
                    type: "info",
                    timer: 2000,
                    showConfirmButton: false
                  }).catch(swal.noop);
                }
        this.loading = false;
      },
        error => {
          this.loading = false;
        })
    }).catch(swal.noop);
  }


    //this.loading = true;

    // this.scrubUpService.DeleteSpeciality(this.token, specltyId, this.appUserDetails.UserId).subscribe(x => {
    //   if (x == "success") {
    //     swal({
    //       title: 'Speciality Deleted Successfully',
    //       type: "success",
    //       timer: 2000,
    //       showConfirmButton: false
    //     }).catch(swal.noop);;
    //     this.OnCancel();
    //     this.GetSpecialities();
    //   }
    //   else {
    //     swal({
    //       title: 'Could Not Delete Speciality',
    //       type: "info",
    //       timer: 2000,
    //       showConfirmButton: false
    //     }).catch(swal.noop);
    //   }
    //   this.loading = false;
    // });


  UpdateSpeciality(index,updatespecialityId) {
    let speciality: SpecialityDTO;
    this.submitted = true;
    if (this.specialityForm.invalid) {
      return;
  }
     speciality = new SpecialityDTO();
    this.updatespecialityId = this.specialityId;
    this.loading = true;
    let formData = new FormData();
    formData.append('ImagePath',this.image);
    formData.append('Name',this.specialityForm.controls['specialityName'].value);
    formData.append('Description',this.specialityForm.controls['description'].value);
    formData.append('ID',updatespecialityId);
    this.scrubUpService.AddSpeciality(this.token,formData).subscribe(x => {
   //console.log(x);
      if (x.Status == true) {
        swal({
          title: 'Speciality Updated Successfully',
          type: "success",
          timer: 2000,
          showConfirmButton: false
        }).catch(swal.noop);;
        this.OnCancel();
        this.GetSpecialities();
      }
      else if (x.Status == false) {
        swal({
          title: 'Speciality Already Exists',
          type: "info",
          timer: 2000,
          showConfirmButton: false
        }).catch(swal.noop);;
      }
      else {

      }
      this.loading = false;
    });
    this.display="none";
  }

  AddSpecialitiy() {
    let speciality: SpecialityDTO;
    speciality = new SpecialityDTO();
    let formData = new FormData();

    this.submitted = true;
    if (this.specialityForm.invalid) {
      return;
  }


    speciality.ID = 0;
    this.specialityId = 0;

    // console.log(JSON.stringify(speciality));
    formData.append('Name',this.specialityForm.controls['specialityName'].value);
    formData.append('Description',this.specialityForm.controls['description'].value);
    formData.append('ImagePath', this.image);
   // console.log(formData.getAll());
    this.loading = true;
    this.scrubUpService.AddSpeciality(this.token,formData).subscribe(x => {
      //console.log(x);

      if (x.Status == true) {
        swal({
          title: 'Speciality Added Successfully',
          type: "success",
          timer: 2000,
          showConfirmButton: false
        }).catch(swal.noop);;
        this.specialityName = "";
        this.description = "";
        this.UserClick(3);
        this.GetSpecialities();
      }
      else if (x.Stastus == false) {
        swal({
          title: 'Speciality Already Exists',
          type: "info",
          timer: 2000,
          showConfirmButton: false
        }).catch(swal.noop);;
      }
      else {

      }
      this.loading = false;
    });
  }

  ngOnInit() {
    this.GetSpecialities();
    this.specialityformvalidation();
    //this.GetProcedures();
  }

  specialityformvalidation()
{
  this.specialityForm = this.formBuilder.group({
  specialityName: ['',Validators.required],
  description: ['', Validators.required],
  file: '',

} );
}
get f() { return this.specialityForm.controls; }
  // CreateUser() {
  //   let user: UserProfileDTO;
  //   user = new UserProfileDTO();
  //   user.Password = "Scrubup@1234";
  //   user.ConfirmPassword = "Scrubup@1234";
  //   user.Email = "adminuser2scrubup@gmail.com";
  //   user.UserName = "adminuser2scrubup@gmail.com";
  //   user.FirstName = "adminusr";
  //   user.LastName = "auser2";
  //   user.UserId = -1;
  //   user.Roles = new Array<string>();
  //   user.Roles.push("Admin");

  //   this.userService.CreateUser(user, this.token).subscribe(x => {
  //     if (x == "Success") {

  //       this.loading = false;
  //     }
  //     else if (x == "Exist") {
  //      // this.showAlreadyExist = true;
  //       this.loading = false;
  //     }
  //     else
  //       this.loading = false;
  //   },
  //     error => {
  //       this.loading = false;
  //     });

  // }
}





// WEBPACK FOOTER //
// /Users/mowebdevice/Desktop/Web Project/angular-scrubup/src/app/speciality/speciality.component.ts